<div class="munkaido-admin">

  <!-- Fejléc + hónapváltó (08-munkaido.html) -->
  <div class="wt-head">
    <div class="wt-head__titles">
      <h1 class="stk-page-title">Munkaidő admin</h1>
      <div class="stk-page-sub">Admin nézet — válaszd ki a munkatársat, állítsd az óraszámot, szabadságot, órabért.</div>
    </div>
    <div class="wt-month-nav">
      <button type="button" class="wt-month-nav__btn" title="Előző hónap" (click)="prevMonth()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="14,6 8,12 14,18"></polyline></svg>
      </button>
      <span class="wt-month-nav__label">{{ monthLabel }}</span>
      <button type="button" class="wt-month-nav__btn" title="Következő hónap" (click)="nextMonth()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="10,6 16,12 10,18"></polyline></svg>
      </button>
    </div>
  </div>

  <!-- Havi összesítő: mindenki egy sorban (óra, szabadság, távollét, bér) -->
  <div class="wt-overview">
    <div class="wt-overview__head">
      <div class="wt-overview__title">{{ overviewTitle }}</div>
      <span class="wt-overview__spacer"></span>
      <button type="button" class="wt-btn-cancel" [disabled]="!overview.length" (click)="exportOverview()">Letöltés (CSV)</button>
    </div>
    <div class="wt-overview__scroll">
      <table class="wt-overview__table">
        <thead>
          <tr>
            <th>Munkatárs</th>
            <th class="num">Ledolgozott</th>
            <th class="num">Munkanap</th>
            <th class="num">Szabadság</th>
            <th class="num">Beteg</th>
            <th class="num">Távollét</th>
            <th class="num">Maradék szab.</th>
            <th class="num">Órabér</th>
            <th class="num">Várható bruttó</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of overview" [class.active]="r.userId === selectedUserId" (click)="pickOverviewRow(r)">
            <td>
              <span class="wt-overview__name">{{ r.name }}</span>
              <span class="wt-ext-pill" *ngIf="r.employmentType === 'external'">Külsős</span>
            </td>
            <td class="num">
              {{ hl(r.workedHours) }} <span class="muted">/ {{ hl(r.requiredHours) }}</span>
              <div class="warn" *ngIf="r.openDays">{{ r.openDays }} nap vége hiányzik</div>
            </td>
            <td class="num">{{ r.daysWorked }}</td>
            <td class="num">{{ r.employmentType === 'external' ? '—' : r.vacationDaysInMonth + ' nap' }}</td>
            <td class="num">{{ r.employmentType === 'external' ? '—' : r.sickDaysInMonth + ' nap' }}</td>
            <td class="num">
              {{ r.absenceHoursInMonth ? hl(r.absenceHoursInMonth) : '—' }}
              <div class="muted" *ngIf="r.absenceDaysInMonth">{{ r.absenceDaysInMonth }} egész nap</div>
            </td>
            <td class="num">{{ r.employmentType === 'external' ? '—' : r.vacationDaysLeft + ' nap' }}</td>
            <td class="num">{{ r.hourlyWage ? ft(r.hourlyWage) : '' }}<span class="warn" *ngIf="!r.hourlyWage">nincs</span></td>
            <td class="num strong">{{ ft(r.expectedGrossSalary) }}</td>
          </tr>
          <tr *ngIf="!overview.length">
            <td colspan="9" class="muted">{{ overviewLoading ? 'Betöltés…' : 'Nincs adat.' }}</td>
          </tr>
        </tbody>
        <tfoot *ngIf="overview.length">
          <tr>
            <td>Összesen</td>
            <td class="num">{{ hl(overviewTotals.worked) }}</td>
            <td></td>
            <td class="num">{{ overviewTotals.vacation }} nap</td>
            <td class="num">{{ overviewTotals.sick }} nap</td>
            <td class="num">{{ hl(overviewTotals.absence) }}</td>
            <td></td>
            <td></td>
            <td class="num strong">{{ ft(overviewTotals.salary) }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>

  <!-- User-választó + Beállítások (wtIsAdmin) -->
  <div class="wt-admin-bar">
    <div class="wt-admin-bar__users">
    <button *ngFor="let u of users"
            type="button"
            class="wt-user-chip"
            [class.wt-user-chip--active]="u.id === selectedUserId"
            (click)="pickUser(u)">
      <span class="wt-avatar wt-avatar--sm" [style.background]="u.color" [appUserAvatar]="u.name">{{ u.initial }}</span>
      {{ u.name }}
      <span class="wt-ext-pill" *ngIf="u.external">Külsős</span>
    </button>
    </div>
    <span class="wt-admin-bar__spacer"></span>
    <button type="button" class="wt-settings-btn" (click)="toggleSettings()">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3.2"></circle><path d="M19 12 a7 7 0 0 0 -0.1 -1.2 l2 -1.6 -2 -3.4 -2.4 1 a7 7 0 0 0 -2 -1.2 L14 3 h-4 l-0.5 2.6 a7 7 0 0 0 -2 1.2 l-2.4 -1 -2 3.4 2 1.6 a7 7 0 0 0 0 2.4 l-2 1.6 2 3.4 2.4 -1 a7 7 0 0 0 2 1.2 L10 21 h4 l0.5 -2.6 a7 7 0 0 0 2 -1.2 l2.4 1 2 -3.4 -2 -1.6 a7 7 0 0 0 0.1 -1.2 Z"></path></svg>
      Beállítások
    </button>
  </div>

  <!-- Konfig kártya (wtSettingsOpen) -->
  <div class="wt-settings" *ngIf="settingsOpen">
    <div class="wt-settings__title">{{ settingsTitle }}</div>
    <div class="wt-settings__grid">
      <div *ngFor="let f of visibleCfgFields">
        <div class="wt-settings__label">{{ f.label }}</div>
        <div class="wt-settings__row">
          <input type="number" min="0" class="wt-settings__input" [value]="cfgValue(f.key)" (change)="onCfgChange(f.key, $event)">
          <span class="wt-settings__unit">{{ f.unit }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Havi kártyák (wtKpis) — külsősnél nincs szabadság / betegszabadság -->
  <div class="wt-kpis" [class.wt-kpis--three]="isExternal">
    <div class="wt-kpi" *ngFor="let k of kpis">
      <div class="wt-kpi__label">{{ k.label }}</div>
      <div class="wt-kpi__value" [style.color]="k.valColor">{{ k.value }}</div>
      <div class="wt-kpi__sub">{{ k.sub }}</div>
    </div>
  </div>

  <!-- Havi naptár (wtCells) -->
  <div class="wt-cal">
    <div class="wt-cal__heads">
      <div class="wt-cal__head" *ngFor="let d of dayHeads">{{ d }}</div>
    </div>
    <div class="wt-cal__grid">
      <ng-container *ngFor="let c of cells">
        <div *ngIf="c.blank"></div>
        <div *ngIf="!c.blank"
             class="wt-cell"
             [class.wt-cell--weekend]="c.weekend"
             [class.wt-cell--vacation]="c.kind === 'vacation'"
             [class.wt-cell--sick]="c.kind === 'sick'"
             [class.wt-cell--absence]="c.kind === 'absence'"
             [class.wt-cell--planned]="c.kind === 'planned'"
             [class.wt-cell--today]="c.today"
             (click)="openDay(c)">
          <div class="wt-cell__top">
            <span class="wt-cell__num"
                  [class.wt-cell__num--weekend]="c.weekend"
                  [class.wt-cell__num--today]="c.today">{{ c.num }}</span>
            <span class="wt-cell__spacer"></span>
            <svg *ngIf="c.hasComment" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#9AA098" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12 a8 8 0 1 0 -3.1 6.3 L21 20 Z"></path></svg>
          </div>
          <div class="wt-cell__time" *ngIf="c.timeLabel">{{ c.timeLabel }}</div>
          <div *ngIf="c.typeLabel"><span class="wt-pill {{ c.pillClass }}">{{ c.typeLabel }}</span></div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Előre jelzett távollétek (heti ismétlődő vagy egyszeri) -->
  <app-wt-plans [userId]="plansUserId" (changed)="reload()"></app-wt-plans>

  <!-- Nap modál -->
  <div class="wt-modal-overlay" *ngIf="draft" (click)="closeDay()">
    <div class="wt-modal" (click)="$event.stopPropagation()">
      <div class="wt-modal__head">
        <h2 class="wt-modal__title">{{ modalTitle }}</h2>
        <button type="button" class="wt-modal__close" title="Bezárás" (click)="closeDay()">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>
        </button>
      </div>

      <div class="wt-type-chips" [class.wt-type-chips--single]="isExternal">
        <button *ngFor="let c of visibleTypeChips"
                type="button"
                class="wt-type-chip"
                [class.wt-type-chip--active]="draft.type === c.t"
                (click)="setDraftType(c.t)">{{ c.label }}</button>
      </div>
      <div class="wt-type-hint" *ngIf="isExternal">Külsős munkatárs — munkanap vagy távollét rögzíthető, nincs szabadság-elszámolás.</div>

      <div class="wt-type-hint" *ngIf="modalPlan">{{ modalPlanLabel }}</div>

      <ng-container *ngIf="draft.type === 'absence'">
        <div class="wt-times">
          <div>
            <div class="wt-field__label">Távol ettől</div>
            <input type="time" class="wt-field__input" [value]="draft.start" (change)="onStartChange($event)">
          </div>
          <div>
            <div class="wt-field__label">Eddig</div>
            <input type="time" class="wt-field__input" [value]="draft.end" (change)="onEndChange($event)">
          </div>
        </div>
        <div class="wt-field__hint wt-absence-hint">Üresen hagyva egész napos távollét. Nem fizetett, a szabadságkeretet nem érinti.</div>
      </ng-container>

      <ng-container *ngIf="draft.type === 'work'">
        <div class="wt-times">
          <div>
            <div class="wt-field__label">Munkakezdés</div>
            <input type="time" class="wt-field__input" [value]="draft.start" (change)="onStartChange($event)">
          </div>
          <div>
            <div class="wt-field__label">Munka vége</div>
            <input type="time" class="wt-field__input" [value]="draft.end" (change)="onEndChange($event)">
            <div class="wt-field__hint">Hagyd üresen, ha még dolgozol — távozáskor írd be.</div>
          </div>
        </div>
        <div class="wt-draft-hours"
             [class.wt-draft-hours--done]="draftDone && !draftInvalidRange"
             [class.wt-draft-hours--error]="draftInvalidRange">{{ draftHours }}</div>
      </ng-container>

      <div class="wt-comment">
        <div class="wt-field__label">Komment</div>
        <textarea rows="2" placeholder="pl. Csütörtökön el kell mennem 2 órára…" [value]="draft.comment" (input)="onCommentChange($event)"></textarea>
      </div>

      <div class="wt-modal-actions">
        <button *ngIf="modalHadEntry" type="button" class="wt-btn-delete" (click)="deleteDay()">Bejegyzés törlése</button>
        <span class="wt-modal-actions__spacer"></span>
        <button type="button" class="wt-btn-cancel" (click)="closeDay()">Mégse</button>
        <button type="button" class="wt-btn-save" [disabled]="draftInvalidRange || saving" (click)="saveDay()">Mentés</button>
      </div>
    </div>
  </div>

</div>
